// extracted by mini-css-extract-plugin
export default {"coverLink":"lM-z","contentBox":"mM-z","zapposPromoContainer":"nM-z","zapposPromoGroupContainer":"oM-z","promos":"pM-z","bottom":"qM-z","top":"rM-z","right":"sM-z","left":"tM-z"};